import { Col, Flex, Row } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import {
    PageContent,
    PageSection,
} from "../../../../styles/global/Pages.styled";
import Theme from "../../../../styles/Theme/Theme";
import { toSnakeCase } from "../../../../utils/hooks/stringSerialization";

const SegmentedWarper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 1%;
`;

const SegmentedControlStyle = styled.div`
  display: flex;
  background-color: ${Theme.color["white"]};
  border-radius: 30px;
  /* box-shadow: ${Theme.shadow.level3}; */
  height: 45px; //50px
  gap: 10px; //20px
  padding: 0 10px;
`;

const ButtonLink = styled.div`
  background-color: ${(props) =>
        props.$backgroundColor ? Theme.color["black-1"] : Theme.color["white"]};
  color: ${(props) =>
        props.$backgroundColor ? Theme.color["white"] : Theme.color["black-1"]};
  height: 35px; //40px
  border-radius: 30px;
  align-self: center;
  display: flex;
  cursor: pointer;
  text-align: -webkit-center;

  > p {
    align-self: center;
    padding: 0 24px;
  }
`;

export const ConfigurationHeader = ({
    buttons,
    changeHeaderSelectedTab,
    headerSelectedTab,
    subTabPath,
}) => {
    const { t } = useTranslation();
    const [selectedTab, setSelectedTab] = useState(headerSelectedTab);

    useEffect(() => {
        setSelectedTab(headerSelectedTab);
    }, [headerSelectedTab]);

    function changeTab(tab) {
        setSelectedTab(tab);
        changeHeaderSelectedTab(tab);
    }

    return (
        <PageContent>
            <PageSection $padding={`${Theme.spacing["s06"]} ${Theme.spacing["s04"]}`}>
                <Flex>
                    <Row style={{ width: "100%" }}>
                        <Col span={12} offset={6}>
                            {buttons?.length > 1 ? (
                                <SegmentedWarper>
                                    <SegmentedControlStyle>
                                        {buttons?.map((buttonName, index) => {
                                            return (
                                                <ButtonLink
                                                    key={index}
                                                    onClick={() => changeTab(subTabPath[index])}
                                                    $backgroundColor={subTabPath.indexOf(selectedTab) === index}
                                                >
                                                    <p>{t(`button.${toSnakeCase(buttonName)}`)}</p>
                                                </ButtonLink>
                                            );
                                        })}
                                    </SegmentedControlStyle>
                                </SegmentedWarper>
                            ) : null}
                        </Col>
                    </Row>
                </Flex>
            </PageSection>
        </PageContent>
    );
};
